/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcuts_GeneralInputs */

const en_shortcuts_general = /** @type {(inputs: Shortcuts_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Shortcuts_GeneralInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const shortcuts_general = /** @type {((inputs?: Shortcuts_GeneralInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcuts_GeneralInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_shortcuts_general(inputs)
});